import React from 'react'

const AdministratorPage = () => {
  return (
    <div>AdministratorPage</div>
  )
}

export default AdministratorPage